module.exports = "/assets/data/fa85e2acb5c1c137abc2c5ff3012279d-CF63.data.json";